/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-14 14:34:29
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-30 10:44:07
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/SortableTree/index.tsx
 */
import React, { Component } from 'react';
import SortableTree, { getFlatDataFromTree } from 'react-sortable-tree';
import css from './css.module.less';
import 'react-sortable-tree/style.css'; // This only needs to be imported once in your app
import CustomTheme from './Theme/index';
//import _ from 'lodash';
//import CustomRender from './node-renderer-default';
const _h = 72;
class Navigation extends Component<any, any> {
  constructor(props) {
    super(props);
    const getNodeKey = (a) => {
      return a.treeIndex;
    };
    const { tree } = props;
    const currentLayer = getFlatDataFromTree({
      treeData: tree,
      getNodeKey,
    }).length;

    this.state = {
      //menuItems: rawData || [],
      isDragging: false,
      height: currentLayer * _h,
    };
    // this.replaceButtonIcon = this.replaceButtonIcon.bind(this);
  }

  componentDidMount() {
    // const { tree, onChange } = this.props;
    // const tempTree = _.cloneDeep(tree);
    // tempTree.forEach((i) => {
    //   if (i.children && i.children.length > 0) {
    //     i.expanded = true;
    //   }
    // });
    // if (onChange) onChange(tempTree);
  }
  componentDidUpdate(preProps, preState) {
    const { tree, onDragging } = this.props;
    const { isDragging } = this.state;
    const getNodeKey = (a) => {
      return a.treeIndex;
    };
    if (tree !== preProps.tree) {
      const currentLayer = getFlatDataFromTree({
        treeData: tree,
        getNodeKey,
      }).length;
      this.setState({
        height: currentLayer * _h,
      });
    }
    if (isDragging !== preState.isDragging) {
      if (onDragging) onDragging(isDragging);
    }
  }

  render() {
    const {
      tree,

      onChange,
      childGenerator,
      disabled,
      //canDrag,
    } = this.props;
    const { height } = this.state;
    //可以获得层级;
    //this.replaceButtonIcon();

    return (
      <div className={css.wrapper} style={{ height: height }}>
        <SortableTree
          canDrag={!disabled}
          //className={containerCss}
          theme={CustomTheme}
          treeData={tree || []}
          maxDepth={2}
          rowHeight={_h}
          onDragStateChanged={({ isDragging }) => {
            this.setState({ isDragging });
          }}
          //maxDepth={2}
          onChange={(tree) => {
            if (onChange) onChange(tree);
          }}
          generateNodeProps={({ node, path }) => {
            return {
              title: childGenerator(node, path),
            };
          }}
        />
      </div>
    );
  }
}
export default Navigation;
